
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-decisioning/iterable",
      function () {
        return require("private-next-pages/ai-decisioning/iterable.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-decisioning/iterable"])
      });
    }
  